import React, { useState, useEffect } from "react";
import axios from "axios";
import { FB_URL } from '../store/actions/types';

const CryptoPriceColumn = () => {
  const [prices, setPrices] = useState({ mevision: null });
  const [error, setError] = useState(null);

  const fetchMEV = async () => {
    const blank = "";
    const res = await axios.post(`${FB_URL}/m110-getmevprice`, {
      aaa: blank,
      bbb: blank,
      ccc: blank,
    });
    return Number(res.data.MEVprice);
  };

  const fetchCryptoPrices = async () => {
    try {
      const MEVprice = await fetchMEV();
      setPrices({ mevision: MEVprice });
      setError(null);
    } catch (error) {
      console.error("Fetch error:", error);
      setError("Error loading price");
    }
  };

  useEffect(() => {
    fetchCryptoPrices();  // Fetch immediately on mount
    const interval = setInterval(fetchCryptoPrices, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      fontSize: '20px',         // Larger text
      fontWeight: 'bold',
      color: '#000000',         // Black for visibility (or '#FFFFFF' on dark bg)
      textAlign: 'center',
    }}>
      <b>MEV:</b> ${prices.mevision ? prices.mevision.toFixed(5) : (error || "Loading...")}
    </div>
  );
};

export default CryptoPriceColumn;
//////////////////////////////////////////////////////////////////////////////////
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FB_URL } from '../store/actions/types'
// import {
//   isMobile,
//   isBrowser
// } from 'react-device-detect'

// const CryptoPriceColumn = () => {
//   const [prices, setPrices] = useState({
//     // bitcoin: null,
//     // ethereum: null,
//     // bnb: null,        // ← changed from dogecoin
//     mevision: null,
//   });

//   const fetchMEV = async () => {
//      const blank = "";
//      const res = await axios.post(`${FB_URL}/m110-getmevprice`, {
//       aaa: blank,
//       bbb: blank,
//       ccc: blank,
//     });
    
//     const MEVprice = Number(res.data.MEVprice);
//     return MEVprice;
//   }

//   const fetchCryptoPrices = async () => {
//     try {
//       // Updated CoinGecko ids: bitcoin,ethereum,binancecoin
//       const response = await axios.get(
//         "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,binancecoin&vs_currencies=usd"
//       );
  
//       const MEVprice = await fetchMEV();

//       setPrices({
//         // bitcoin: response.data.bitcoin.usd,
//         // ethereum: response.data.ethereum.usd,
//         // bnb: response.data.binancecoin.usd,   // ← now BNB
//         mevision: MEVprice
//       });
//     } catch (error) {
//       // error handling unchanged
//     }
//   };

//   useEffect(() => {
//    // fetchCryptoPrices(); // Fetch prices on component mount
//     const interval = setInterval(fetchCryptoPrices, 60000); // Update every minute
//     return () => clearInterval(interval); // Cleanup on unmount
//   }, []);

//   return (
//     <div>
//  <b>&nbsp;MEV:</b> &nbsp;${prices.mevision ? prices.mevision.toFixed(5) : "Loading..."}
//     </div>
//   );
// };

// export default CryptoPriceColumn;
